// Пункт меню с подменю: стрелка раскрывает и сворачивает список, ссылка
// рядом ведёт на страницу как обычно. Один и тот же пункт живёт и в шапке,
// где подменю выпадает поверх страницы (там его открывает ещё и наведение,
// это в стилях), и в мобильной шторке, где оно раздвигает список.
export default function menuSubmenu(item) {
    const toggle = item.querySelector(".submenu-toggle");

    if (!toggle) {
        return;
    }

    // Выпадашку в шапке закрываем, когда внимание ушло с пункта. В шторке
    // раскрытый список никому не мешает — пусть остаётся, пока не свернут
    const isDropdown = !!item.closest(".page-header");

    function setOpen(isOpen) {
        item.classList.toggle("open", isOpen);
        toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
    }

    toggle.addEventListener("click", function () {
        setOpen(!item.classList.contains("open"));
    });

    item.addEventListener("keydown", function (event) {
        if (event.key === "Escape" && item.classList.contains("open")) {
            setOpen(false);
            toggle.focus();
        }
    });

    if (isDropdown) {
        document.addEventListener("click", function (event) {
            if (!item.contains(event.target)) {
                setOpen(false);
            }
        });

        item.addEventListener("focusout", function (event) {
            if (!item.contains(event.relatedTarget)) {
                setOpen(false);
            }
        });
    }
}
